import React from "react";

export function ProductOutOfStock(props:any) {
	return (
		<div>
			<a  onClick={props.clickHandler} data-max-cart={props.max_qnt_cart}
	            data-qnt-cart={props.curr_qnt}
	            data-add-cart={props.product_id}
	            className="outstock" rel="nofollow">{props.add_to_btn_txt}
	        </a>
        </div>
	);
}